module.exports = __webpack_public_path__ + "img/realname.de9527f5.jpg";